export default "__VITE_PUBLIC_ASSET__92565203__"